'use strict';

var UserFareExclusionRulesDirective = function UserFareExclusionRulesDirective() {
  return {
    restrict: 'E',
    controller: 'UserFareExclusionRulesController',
    template: require('../templates/user-fare-exclusion-rules.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
UserFareExclusionRulesDirective.$inject = [];
module.exports = UserFareExclusionRulesDirective;